import React, {Component, Fragment} from 'react';
import {hot} from 'react-hot-loader';
import {Route, Router, Switch} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Provider} from 'react-redux';
import b_ from 'b_';

import history from 'client/common/utils/history';
import {BundleProps} from 'client/common/types/bundle';
import MetricInitializer from 'client/common/components/metric-initializer';
import {QuicksurveyStore} from 'client/common/types/store';
import reducer from 'client/common/store/reducers/quicksurvey';
import rootSaga from 'client/common/store/saga/quicksurvey';
import getStore from 'client/common/store';
import {renderBundle} from 'client/common/utils/bundle';
import {UserProvider} from 'client/common/contexts/user';

import ArticleListPage from './components/articles-list/articles-list';
import ArticlePage from './components/article/article';
import './article.css';

const b = b_.with('article-page');

class ArtBundle extends Component<BundleProps> {
    store = getStore<QuicksurveyStore>(this.props.state, {reducer, rootSaga});
    render() {
        return (
            <Provider store={this.store}>
                <UserProvider value={this.props.state.user}>
                    <Router history={history}>
                        <div className={b()}>
                            <Fragment>
                                <Helmet>
                                    <html />
                                </Helmet>
                                <MetricInitializer />
                                <Switch>
                                    <Route exact path='/articles' component={ArticleListPage} />
                                    <Route
                                        exact
                                        path='/articles/tag/:tag'
                                        component={ArticleListPage}
                                    />
                                    <Route exact path='/articles/:slug' component={ArticlePage} />
                                </Switch>
                            </Fragment>
                        </div>
                    </Router>
                </UserProvider>
            </Provider>
        );
    }
}

const ArticlesBundle = hot(module)(ArtBundle);

export default renderBundle(ArticlesBundle);
